import { render, staticRenderFns } from "./PastEventDetailsTable.vue?vue&type=template&id=6afe1dce"
import script from "./PastEventDetailsTable.vue?vue&type=script&lang=ts"
export * from "./PastEventDetailsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports